<template>
    <div>
        <div class="block">
            <el-carousel height="150px">
            <el-carousel-item v-for="item in arr" :key="item.url">
                <img :src="item.url" alt="">
            </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            arr:[
                {url: require('../../assets/sw1.png')},
                {url: require('../../assets/sw2.png')},
                {url: require('../../assets/sw3.png')},
            ]
        }
    },
    mounted(){
        
    }

}
</script>

<style lang="less" scoped>
.block{
    width: 294px;
    margin-top: 15px;
}
.el-carousel__item h3 {
    text-align: center;
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
} 
.el-carousel__item img{
    width: 100%;
    height: 100%;
}
</style>
